var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('parts',{attrs:{"cols":2,"title":"クリア"},on:{"remove":function($event){return _vm.$emit('remove')}}},[_c('td',[_c('b-form-select',{attrs:{"options":[
        { value:'front3', text:'紹介/テロップ' },
        { value:'bg2', text:'背景' },
        { value:'bg3', text:'効果' } ]},model:{value:(_vm.form.layer),callback:function ($$v) {_vm.$set(_vm.form, "layer", $$v)},expression:"form.layer"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }